import * as persistanceKeys from '@web-platform/shared-universal-constants/src/persistanceKeys';
import { SEARCH_PARAMS_CHANGED } from '@web-platform/shared-universal-constants/src/userSearch';
import { tryGetValue } from '@web-platform/shared-universal-utils-frontend/src/helpers/sessionStorage';

import { BAGGAGE_FILTER_CHANGED, FILTERS_RESET } from '../../../../../../actions/filters';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { BaggageFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/baggage';

export const INITIAL_STATE: BaggageFilterState = { cabinBag: false, checkedBag: false };

const storedStateFilters = () =>
  tryGetValue(persistanceKeys.FILTERS, { baggage: INITIAL_STATE })?.baggage ?? INITIAL_STATE;

export const createBaggageReducer =
  (getInitialState: () => BaggageFilterState = storedStateFilters) =>
  (state: BaggageFilterState = getInitialState(), action: Action): BaggageFilterState => {
    switch (action.type) {
      case SEARCH_PARAMS_CHANGED: {
        const { fareAttributes } = action.payload.searchParams;
        if (!fareAttributes) {
          return state;
        }

        return {
          cabinBag: fareAttributes.includes('cabinBag'),
          checkedBag: fareAttributes.includes('checkedBag'),
        };
      }
      case BAGGAGE_FILTER_CHANGED: {
        return {
          cabinBag: action.payload.cabinBag,
          checkedBag: action.payload.checkedBag,
        };
      }

      case FILTERS_RESET: {
        return INITIAL_STATE;
      }

      default:
        return state;
    }
  };

export default createBaggageReducer();
export const get = (state: BaggageFilterState): BaggageFilterState => state;
